import ENDPOINTS from 'api/endpoints';
import { doGet, doPost } from 'api/request';
import type { CreateAssistantVoiceOption } from 'api/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { TTSProviderVoiceConfig } from './types';

export const getTTSProviderVoiceConfig = (
  provider: string,
  voiceId: string,
  humeProvider?: string,
) => {
  const encodedVoiceID = encodeURIComponent(voiceId.trim());
  const params = new URLSearchParams();
  if (humeProvider) {
    params.set('hume_provider', humeProvider);
  }
  const queryString = params.toString();
  const path = generateNextPath(ENDPOINTS.PROVIDER_VOICE_CONFIG, {
    provider,
    voiceId: encodedVoiceID,
  });
  return doGet<TTSProviderVoiceConfig>(
    queryString ? `${path}?${queryString}` : path,
    LOGGER_TYPE.JUPITER,
    { version: 'v1' },
  );
};

export const getTTSProviderModels = (provider: string) => {
  return doGet<string[]>(
    generateNextPath(ENDPOINTS.PROVIDER_VOICE_MODEL, {
      provider,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v1' },
  );
};

export const createVoice = (
  accountId: string,
  request: CreateAssistantVoiceOption,
) => {
  return doPost<CreateAssistantVoiceOption>(
    generateNextPath(ENDPOINTS.VOICES, { accountId }),
    LOGGER_TYPE.JUPITER,
    request,
    { version: 'v1' },
  );
};
